import React, { useEffect, useMemo, useState, useTransition } from "react";
import { Col, Row } from "react-bootstrap";
import UserStatusCard from "./UserStatus";
import RecentActivityCard from "./RecentActivity";
import ImageStatusCards from "./ImageStatsus";
import MasterCharts from "./MasterCharts";
import { modelList } from "../../../content/imageOverview";
import ProfileCard from "../../../pages/Profile/ProfileCard";
import dashboard from "lib/deshboard-client";


const AdminDashboard = () => {
  const [masterData, setMasterData] = useState([]);
  const [modalList, setModalList] = useState([]);
  const [selectedModal, setSelectedModal] = useState(null);
  const [isStyle, setIsStyle] = useState(true);
  const [imageValidtionCount, setImageValidtionCount] = useState([]);
  const [imageValidtion, setImageValidtion] = useState({});
  const [gImgValidate, setGImgValidate] = useState();
  const [isDownload, setIsDownload] = useState(false);
  const [loadingImageValidtion, startTansitionImageValidtion] = useTransition();
  const [isPendingMaster, startTransition] = useTransition();

  const isImageLibary = useMemo(() =>
    modelList.some(_state => _state?.value === selectedModal?.value),
    [selectedModal]
  );

  const fetchReports = async (modalValue) => {
    const { data } = await dashboard.fetchReports(modalValue)
    startTransition(() => {
      setMasterData(data || {});
    });
  };

  const fetchModalList = async () => {
    const { updatedList } = await dashboard.fetchModalList()
    setModalList(updatedList);
    setSelectedModal(updatedList[0]);
  };

  const fetchImageValidation = async (model) => {
    const { report, currentSatus, statsArray, folderWiseReport, cscWiseReport, totalImage } = await dashboard.fetchImageValidation(model, isStyle)

    startTansitionImageValidtion(() => {
      if (currentSatus) {
        setGImgValidate(currentSatus)
      }
      console.log("statsArray",statsArray)
      setImageValidtionCount(statsArray);
      setImageValidtion({ ...report.data.data, totalImage, cscWiseReport, folderWiseReport } || {});
    })
  }

  const downloadImageValidationReport = async () => {
    setIsDownload(true)
    const { error } = await dashboard.fetchImageValidation(selectedModal.value, isStyle)
    setIsDownload(false)
  };

  const imageValidationHandle = async () => {
    const { data, error } = dashboard.imageValidationHandle(selectedModal.value, isStyle)
    setGImgValidate(data || error.response.data || error.message)
  }

  const tabHandle = () => setIsStyle(_state => !_state)

  useEffect(() => {
    fetchModalList();
  }, []);

  useEffect(() => {
    if (selectedModal) {
      fetchReports(selectedModal.value);
      if (isImageLibary) {
        fetchImageValidation(selectedModal.value)
      } else {
        setImageValidtionCount({ available: 0, totalImage: 0, unavailable: 0 });
        setImageValidtion({});
      }
      setGImgValidate(null)
    }
  }, [selectedModal]);

  useEffect(() => {
    if (selectedModal) {
      fetchImageValidation(selectedModal.value)
      setGImgValidate(null)
    }
  }, [isStyle]);

  return (
    <>
      <Row className="mb-4 gx-3 gy-4">
        <Col md={3} className="p-3">
          <ProfileCard />
        </Col>

        <UserStatusCard />

        <RecentActivityCard
          selectedModal={selectedModal}
          modalList={modalList}
          setSelectedModal={setSelectedModal}
          masterData={masterData}
          imageValidtion={imageValidtion}
          gImgValidate={gImgValidate}
          isImageLibary={isImageLibary}
          isStyle={isStyle}
          tabHandle={tabHandle}
          imageValidationHandle={imageValidationHandle}
          isDownload={isDownload}
          downloadImageValidationReport={downloadImageValidationReport}
        />
      </Row>

      {isImageLibary && (
        <ImageStatusCards
          loadingImageValidtion={loadingImageValidtion}
          imageValidtionCount={imageValidtionCount}
          imageValidtion={imageValidtion}
        />
      )}

      <MasterCharts
        isPendingMaster={isPendingMaster}
        masterData={masterData}
      />
    </>
  );
};

export default AdminDashboard;